import React from 'react';
import DayCell from './DayCell';
import { getDayNames } from '../../../utils/calendarUtils';
import './Calendar.css';

const CalendarGrid = ({ month, year, attendanceData, onDayClick }) => {
  const dayNames = getDayNames();

  return (
    <div className="calendar-container">
      <div className="calendar-grid">
        {/* Day name headers */}
        {dayNames.map(day => (
          <div key={day} className="calendar-header">
            {day}
          </div>
        ))}
        
        {/* Day cells */}
        {attendanceData.map((dayData, index) => (
          <DayCell
            key={index}
            date={dayData.date}
            attendance={dayData.attendance}
            festival={dayData.festival}
            isCurrentMonth={dayData.isCurrentMonth}
            isToday={dayData.isToday}
            onClick={(e) => onDayClick(dayData, e)}
          />
        ))}
      </div>
    </div>
  );
};

export default CalendarGrid;
